import { DEFAULT_CURRENCY_CODE, Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'entryFirstCurrencySymbol',
  standalone: true
})
export class EntryFirstCurrencySymbolPipe implements PipeTransform {
  constructor(
    @Inject(LOCALE_ID) private _locale: string,
    @Inject(DEFAULT_CURRENCY_CODE) private _defaultCurrencyCode: string = 'CAD'
  ) {}

  transform<T extends { id: string | number }>(
    entry: T | null | undefined,
    entriesArr: T[] | null | undefined,
    debitOrCredit: keyof T,
    decimalPlaces: number = 2
  ): string | null {
    if (!entry) return null;

    const amount = entry[debitOrCredit];
    if (!amount || isNaN(Number(amount))) {
      return null;
    }
    const relevantEntries = entriesArr?.filter(e => e[debitOrCredit] !== null);
    const isFirstEntry = relevantEntries?.first()?.id === entry.id;

    if (isFirstEntry) {
      return new Intl.NumberFormat(this._locale, {
        style: 'currency',
        currency: this._defaultCurrencyCode,
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
      }).format(Number(amount));
    }

    return Number(amount).toLocaleString(this._locale, {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces
    });
  }
}
